<script>
	import Navbar from "../Navbar.svelte";
	import Footer from "../components/Footer.svelte";
	import SvelteMarkdown from "svelte-markdown";
	import {
		handleSubmit,
		parseFormdata,
		parseLucid,
		parseMturk,
		getExpParams,
		writeForm,
	} from "../utils.js";
	import { api_writeForm, disableNextButton } from "../stores.js";
	import { useForm, validators, required } from "svelte-use-form";
	import { getContext } from "svelte";
	import End from "../modals/End.svelte";
	// https://svelte.dev/repl/d4fc021f688d4ad0b3ceb9a1c44c9be9?version=3.34.0

	export let redirectRoute = location.protocol + "//" + location.host;

	let expParams = getExpParams();
	console.log(expParams);
	const redirectURL = decodeURIComponent(expParams["redirect-url"]);
	let customMsg = decodeURIComponent(expParams["custom-msg"]);

	const { open, close } = getContext("simple-modal");
	const showEndMessage = (
		msg,
		text,
		showReturnHomeButton,
		isURL,
		isCompletionCode,
	) => {
		open(
			End,
			{
				msg: msg,
				text: text,
				showReturnHomeButton: showReturnHomeButton,
				isURL: isURL,
				isCompletionCode: isCompletionCode,
				onClose: close,
				redirectRoute: redirectRoute,
			},
			{
				closeButton: false,
				closeOnOuterClick: false,
				styleBg: { "background-color": "grey" },
			},
			{},
		);
	};

	const form = useForm();

	const handleClick = () => {
		let completeText;
		let showReturnHomeButton = false;
		let isURL = false;
		let isCompletionCode = false;

		const responses = parseFormdata($form);
		console.log(responses);
		handleSubmit($api_writeForm, responses);

		console.log("checkpoint");
		writeForm($api_writeForm, {
			checkpoint: "end-redirect",
		});

		// for debugging
		// expParams.experiment_id = 'sdfd';
		// expParams.platform = 'prolific';
		if (
			expParams.experiment_id === "solarflare" ||
			localStorage.getItem("experiment_id") === "solarflare"
		) {
			completeText = "";
			showReturnHomeButton = true;
			console.log("Show return home button");
		} else {
			showReturnHomeButton = false;
			console.log("platform:", expParams.platform);
			if (expParams.platform === "lucid") {
				completeText = parseLucid(redirectURL);
				isURL = true;
			} else if (expParams.platform === "mturk") {
				completeText = parseMturk();
				isCompletionCode = true;
			} else if (expParams.platform === "prolific") {
				completeText = redirectURL;
				isURL = true;
			} else {
				showReturnHomeButton = false;
			}
			console.log("completeText:", completeText);
		}

		// console.log("Remove condition and experiment_id in localStorage");
		// localStorage.removeItem("condition");
		// localStorage.removeItem("experiment_id");
		// localStorage.removeItem("experiment_parameters");
		// localStorage.removeItem("queryParams");
		// localStorage.removeItem("redirectionRoutes");
		// localStorage.removeItem("nextRoute");
		// localStorage.setItem("complete", 1);

		showEndMessage(
			customMsg,
			completeText,
			showReturnHomeButton,
			isURL,
			isCompletionCode,
		);
	};
</script>

<Navbar />

<section>
	{#if expParams["custom-msg-type"] == "modal"}
		<div class="button-container">
			<button
				disabled={!$form.valid && $disableNextButton}
				on:click|preventDefault={handleClick}>Continue</button
			>
		</div>
	{:else}
		<SvelteMarkdown source={customMsg} />
	{/if}
</section>

<Footer />

<style>
	@media (max-width: 700px) {
		section {
			padding-left: 8%;
			padding-right: 8%;
		}
	}

	.button-container {
		display: flex;
		justify-content: center;
	}

	button {
		margin-top: 34px;
		margin-bottom: 34px;
	}
</style>
